export const rowsHighCh1: Record<number, number> = {
	17: 2,
	18: 4,
	21: 6,
	22: 8,
	23: 10,
	19: 13,
	20: 15,
}
